import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";

export default {
  Point: new Style({
    image: new CircleStyle({
      radius: 4,
      fill:new Fill({color: 'red'}),
      stroke: new Stroke({
      color: "magenta",
      }),
    }),
  }),
  SmallPoint: new Style({
    image: new CircleStyle({
      radius: 2,
      fill:new Fill({color: 'red'}),
      stroke: new Stroke({
      color: "red",
      }),
    }),
  }),
  Polygon: new Style({
    stroke: new Stroke({
      color: "blue",
      lineDash: [4],
      width: 3,
    }),
    fill: new Fill({
      color: "rgba(0, 0, 255, 0.1)",
    }),
  }),
  MultiPolygon: new Style({
    stroke: new Stroke({
      color: "blue",
      width: 1,
    }),
    fill: new Fill({
      color: "rgba(0, 0, 255, 0.1)",
    }),
  }),

  Collection : new Style({
    stroke: new Stroke({
      color: 'magenta',
      width: 2,
    }),
    fill: new Fill({
      color: 'magenta',
    }),
    image: new CircleStyle({
      radius: 10,
      fill: null,
      stroke: new Stroke({
        color: 'magenta',
      }),
    }),
  }),
   colors : [{name:'Core Urban',value:'#ec926e'},
{name:'Peri-Urban',value:'#ffc3b6'},
{name:'Other urban area',value:'#ff6969'},
{name:'Village Settlement',value:'#ffcccc'},
{name:'Mixed Village Settlement',value:'#ffc4b7'},
{name:'Hamlets & Dispersed Household',value:'#ffcccc'},
{name:'Other Rural Built-up Areas',value:'#ffc4b7'},
{name:'Industrial Area',value:'#fff1f1'},
{name:'Transport Network',value:'#ffc4b7'},
{name:'Transport Infrastructure',value:''},
{name:'Crop Land',value:'#fff2d5'},
{name:'Fallow Land',value:''},
{name:'Agricultural Plantation',value:'#ebf2be'},
{name:'Aquaculture',value:'#f3faca'},
{name:'Closed Forest',value:'#d7ecbd'},
{name:'Open Forest',value:'#38A402'},
{name:'Forest Plantation',value:'#e8ecbd'},
{name:'Swamparea/Mangrove',value:'#d2f8d2'},
{name:'Grasslands/GrazingLands',value:'#beed8a'},
{name:'Salt Affected Land',value:'#f4f6f4'},
{name:'Gullied land',value:'#cad3ca'},
{name:'Ravinous Land',value:''},
{name:'Waterlogged',value:'#ebe6f7'},
{name:'Dense scrub land',value:'#b7ccb7'},
{name:'Sparse Scrub Land',value:'#e4ece4'},
{name:'Sandy area-Desertic',value:''},
{name:'Sandy area-Coastal',value:''},
{name:'Sandy area-Riverine',value:'#fee4ca'},
{name:'Barren Rocky',value:'#d5cbc0'},
{name:'Stony Waste',value:''},
{name:'River',value:'#c6d8d4'},
{name:'Canal/Drain',value:'#c6d8d4'},
{name:'Lake/Pond',value:'#c0e2ec'},
{name:'Reservoir/Tank',value:'#c0e2ec'},
{name:'Shifting Cultivation area',value:'#fefdf4/#f9f5c6'},
{name:'Snow covered area',value:'#F0F8FF'},
{name:'Glacial area',value:''},
{name:'Mining/Quarry/MiningDump',value:'#fff1f1'},
{name:'Rann',value:''},
{name:'Salt pan',value:''},
{name:'Built-up',value:'#ff6969'},
{name:'Agricultural Land',value:'#ffffed'},
{name:'Forest',value:'#d7ecbd'},
{name:'Wastelands',value:'#e6eae6'},
{name:'Water Bodies',value:'#c0e2ec'},
{name:'Others',value:''},
{name:'Built-up Rural',value:'#ffc4b7'},
{name:'Built-up Urban',value:'#ff6969'},
{name:'Transportation',value:'#ffc4b7'},
{name:'Gullied/RavinousLand',value:'#cad3ca'},
{name:'Sandy Area',value:'#fee4ca'},
{name:'Scrub land',value:'#e4ece4'},
{name:'Barren land',value:'#d5cbc0'},
{name:'River/Stream',value:'#c6d8d4'},
{name:'Snow/Glacialarea',value:'#F0F8FF'},
{name:'Mining/Quarry',value:'#fff1f1'},
{name:'Gently sloping',value:'#fae502'},
{name:'Moderately sloping',value:'#ffab00'},
{name:'Very gently sloping',value:'#bec814'},
{name:'Level to nearly level',value:'#709d2b'},
{name:'Moderately steeply sloping',value:'#f46d00'},
{name:'Very steeply sloping',value:'#b90000'},
{name:'Steeply sloping',value:'#c60800'},
{name:'Shifting cultivation - Current',value:'#f9f5c6'},
{name:'Shifting cultivation - Abandoned',value:'#fefdf4'},
{name:'Distributory canal',value:'#6db9e0'},
{name:'Main canal',value:'#62c3fc'},
{name:'Branch canal',value:'#72bce2'},
{name:'Drain',value:'#c6d8d4'},
{name:'River',value:'#68c6fc'},
{name:'Settlement',value:'#ffa4a4'},
{name:'State Highway',value:'#fff02e'},
{name:'village road',value:'#fae000'},
{name:'Village Road',value:'#fae000'},
{name:'National Highway',value:'#f7d649'},
{name:'Foot Path',value:'#f6d300'},
{name:'City Road',value:'#fce220'},
{name:'Cart Track',value:'#ffd867'},
{name:'District Road',value:'#f0bd00'},
{name:'Kutchha Road',value:'#ffd867'},
{name:'Kutcha Road',value:'#ffd867'},
{name:'Pucca Road',value:'#fff014'},
{name:'Broad gauge',value:'#adaeaf'},
{name:'Metre gauge',value:'#333333'},
{name:'boundary',value:'#ff8000'},
{name:'total',value:'#7799c3'},
{name:'Intensive Agriculture',value:'#ffffbe'},
{name:'Agro-horticulture',value:'#ffff01'},
{name:'Agro-forestry',value:'#d3ffbe'},
{name:'Horticulture',value:'#98e601'},
{name:'Silvipasture',value:'#a8a801'},
{name:'Grazing/Pasture Land',value:'#ffa77f'},
{name:'Production Forestry',value:'#38a801'},
{name:'Afforestation',value:'#01734c'},
{name:'Reclamation of Wasteland',value:'#ffbee8'},
{name:'Aquaculture',value:'#73b2ff'},
{name:'Recreational / Industrial',value:'#a901e6'},
{name:'Contour Trenches',value:'#FFA77F'},
{name:'Earthen Contour Bunds',value:'#A87000'},
{name:'Loose Boulder Check Dam / Gully Plugs'},
{name:'Gabion Structures',value:'#8400A8'},
{name:'Earthen Dams (Nala bund)',value:'#737300'},
{name:'Percolation Tank',value:'#73B2FF'},
{name:'Minor Irrigation Tanks (Surface Water)',value:'#0070FF'},
{name:'Farm Ponds',value:'#004DA8'},
{name:'Subsurface Dykes (across channel bed)',value:'#FF73DF'},
{name:'Arable Areas (Khadins)',value:'#FFFF73'},
{name:'none',value:'#f0f8ff'},
{name:'Stream',value:'#c0e2ec'}],

COLORS:[{name:'Core Urban',value:'#ec926e',rgb:[236,146,110]},
 {name:'Peri-Urban',value:'#ffc3b6',rgb:[255,195,182]},
 {name:'Other urban area',value:'#ff6969',rgb:[255,105,105]},
 {name:'Village Settlement',value:'#ffcccc',rgb:[255,204,204]},
 {name:'Mixed Village Settlement',value:'#ffc4b7',rgb:[255,196,183]},
 {name:'Hamlets & Dispersed Household',value:'#ffcccc',rgb:[255,204,204]},
 {name:'Other Rural Built-up Areas',value:'#ffc4b7',rgb:[255,196,183]},
 {name:'Industrial Area',value:'#fff1f1',rgb:[255,241,241]},
 {name:'Transport Network',value:'#ffc4b7',rgb:[255,196,183]},
 //{name:'Transport Infrastructure',value:'',rgb:[]},
 {name:'Crop Land',value:'#fff2d5',rgb:[255,242,213]},
 //{name:'Fallow Land',value:'',rgb:[]},
 {name:'Agricultural Plantation',value:'#ebf2be',rgb:[235,242,190]},
 {name:'Aquaculture',value:'#f3faca',rgb:[243,250,202]},
 {name:'Closed Forest',value:'#d7ecbd',rgb:[215,236,189]},
 {name:'Open Forest',value:'#38A402',rgb:[56,164,2]},
 {name:'Forest Plantation',value:'#e8ecbd',rgb:[232,236,189]},
 {name:'Swamparea/Mangrove',value:'#d2f8d2',rgb:[210,248,210]},
 {name:'Grasslands/GrazingLands',value:'#beed8a',rgb:[190,237,138]},
 {name:'Salt Affected Land',value:'#f4f6f4',rgb:[244,246,244]},
 {name:'Gullied land',value:'#cad3ca',rgb:[202,211,202]},
 //{name:'Ravinous Land',value:'',rgb:[]},
 {name:'Waterlogged',value:'#ebe6f7',rgb:[235,230,247]},
 {name:'Dense scrub land',value:'#b7ccb7',rgb:[183,204,183]},
 {name:'Sparse Scrub Land',value:'#e4ece4',rgb:[228,236,228]},
 //{name:'Sandy area-Desertic',value:'',rgb:[]},
 //{name:'Sandy area-Coastal',value:'',rgb:[]},
 {name:'Sandy area-Riverine',value:'#fee4ca',rgb:[254,228,202]},
 {name:'Barren Rocky',value:'#d5cbc0',rgb:[213,203,192]},
 //{name:'Stony Waste',value:'',rgb:[]},
 //{name:'River',value:'#c6d8d4',rgb:[198,216,212]},
 {name:'River',value:'#C0E2EC',rgb:[192,226,236]},
 //{name:'Stream',value:'',rgb:[]},
 {name:'Canal/Drain',value:'#c6d8d4',rgb:[198,216,212]},
 {name:'Canal / Drain',value:'#c6d8d4',rgb:[198,216,212]},
 {name:'Lake/Pond',value:'#c0e2ec',rgb:[192,226,236]},
 {name:'Reservoir/Tank',value:'#c0e2ec',rgb:[192,226,236]},
 {name:'Shifting Cultivation area',value:'#fefdf4/#f9f5c6',rgb:[]},
 {name:'Snow covered area',value:'#F0F8FF',rgb:[240,248,255]},
 //{name:'Glacial area',value:'',rgb:[]},
 {name:'Mining/Quarry/MiningDump',value:'#fff1f1',rgb:[255,241,241]},
 //{name:'Rann',value:'',rgb:[]},
 //{name:'Salt pan',value:'',rgb:[]},
 {name:'Built-up',value:'#ff6969',rgb:[255,105,105]},
 {name:'Agricultural Land',value:'#ffffed',rgb:[255,255,237]},
 {name:'Forest',value:'#d7ecbd',rgb:[215,236,189]},
 {name:'Wastelands',value:'#e6eae6',rgb:[230,234,230]},
 {name:'Water Bodies',value:'#c0e2ec',rgb:[192,226,236]},
 {name:'Others',value:'',rgb:[]},
 {name:'Built-up Rural',value:'#ffc4b7',rgb:[255,196,183]},
 {name:'Built-up Urban',value:'#ff6969',rgb:[255,105,105]},
 {name:'Transportation',value:'#ffc4b7',rgb:[255,196,183]},
 {name:'Gullied/RavinousLand',value:'#cad3ca',rgb:[202,211,202]},
 {name:'Sandy Area',value:'#fee4ca',rgb:[254,228,202]},
 {name:'Scrub land',value:'#e4ece4',rgb:[228,236,228]},
 {name:'Barren land',value:'#d5cbc0',rgb:[213,203,192]},
 {name:'River/Stream',value:'#c6d8d4',rgb:[198,216,212]},
 {name:'Snow/Glacialarea',value:'#F0F8FF',rgb:[240,248,255]},
 {name:'Mining/Quarry',value:'#fff1f1',rgb:[255,241,241]},
 {name:'Gently sloping',value:'#fae502',rgb:[250,229,2]},
 {name:'Moderately sloping',value:'#ffab00',rgb:[255,171,0]},
 {name:'Very gently sloping',value:'#bec814',rgb:[190,200,20]},
 {name:'Level to nearly level',value:'#709d2b',rgb:[112,157,43]},
 {name:'Moderately steeply sloping',value:'#f46d00',rgb:[244,109,0]},
 {name:'Very steeply sloping',value:'#b90000',rgb:[185,0,0]},
 {name:'Steeply sloping',value:'#c60800',rgb:[198,8,0]},
 {name:'Shifting cultivation - Current',value:'#f9f5c6',rgb:[249,245,198]},
 {name:'Shifting cultivation - Abandoned',value:'#fefdf4',rgb:[254,253,244]},
 {name:'Distributory canal',value:'#6db9e0',rgb:[109,185,224]},
 {name:'Main canal',value:'#62c3fc',rgb:[98,195,252]},
 {name:'Branch canal',value:'#72bce2',rgb:[114,188,226]},
 {name:'Stream',value:'##c0e2ec',rgb:[192,226,236]},
 {name:'Drain',value:'#c6d8d4',rgb:[198,216,212]},
 {name:'River',value:'#68c6fc',rgb:[104,198,252]},
 {name:'Settlement',value:'#ffa4a4',rgb:[255,164,164]},
 {name:'State Highway',value:'#fff02e',rgb:[255,240,46]},
 {name:'village road',value:'#fae000',rgb:[250,224,0]},
 {name:'Village Road',value:'#fae000',rgb:[250,224,0]},
 {name:'National Highway',value:'#f7d649',rgb:[247,214,73]},
 {name:'Foot Path',value:'#f6d300',rgb:[246,211,0]},
 {name:'City Road',value:'#fce220',rgb:[252,226,32]},
 {name:'Cart Track',value:'#ffd867',rgb:[255,216,103]},
 {name:'District Road',value:'#f0bd00',rgb:[240,189,0]},
 {name:'Kutchha Road',value:'#ffd867',rgb:[255,216,103]},
 {name:'Kutcha Road',value:'#ffd867',rgb:[255,216,103]},
 {name:'Pucca Road',value:'#fff014',rgb:[255,240,20]},
 {name:'Broad gauge',value:'#adaeaf',rgb:[173,174,175]},
 {name:'Metre gauge',value:'#333333',rgb:[51,51,51]},
 {name:'boundary',value:'#ff8000',rgb:[255,128,0,1]},
 {name:'total',value:'#7799c3',rgb:[119,153,195]},
 {name:'Intensive Agriculture',value:'#ffffbe',rgb:[255,255,190]},
 {name:'Agro-horticulture',value:'#ffff01',rgb:[255,255,0]},
 {name:'Agro-forestry',value:'#d3ffbe',rgb:[211,255,190]},
 {name:'Horticulture',value:'#98e601',rgb:[152,230,0]},
 {name:'Silvipasture',value:'#a8a801',rgb:[168,168,0]},
 {name:'Grazing/Pasture Land',value:'#ffa77f',rgb:[255,167,127]},
 {name:'Production Forestry',value:'#38a801',rgb:[56,168,0]},
 {name:'Afforestation',value:'#01734c',rgb:[0,115,76]},
 {name:'Reclamation of Wasteland',value:'#ffbee8',rgb:[255,190,232]},
 {name:'Aquaculture',value:'#73b2ff',rgb:[115,178,255]},
 {name:'Recreational / Industrial',value:'#a901e6',rgb:[169,0,230]},
{name:'Contour Trenches',value:'#FFA77F',rgb:[255,167,127]},
{name:'Earthen Contour Bunds',value:'#A87000',rgb:[168,112,0]},
{name:'Loose Boulder Check Dam / Gully Plugs',value:'#FFEBAF',rgb:[255,235,175]},
{name:'Gabion Structures',value:'#8400A8',rgb:[132,0,168]},
{name:'Earthen Dams (Nala bund)',value:'#737300',rgb:[115,115,0]},
{name:'Percolation Tank',value:'#73B2FF',rgb:[115,178,255]},
{name:'Minor Irrigation Tanks (Surface Water)',value:'#0070FF',rgb:[0,112,255]},
{name:'Farm Ponds',value:'#004DA8',rgb:[0,77,168]},
{name:'Subsurface Dykes (across channel bed)',value:'#FF73DF',rgb:[255,115,223]},
{name:'Arable Areas (Khadins)',value:'#FFFF73',rgb:[255,255,115]},
{name:'none',value:'#f0f8ff',rgb:[240, 248, 255]}
//{name:'Stream',value:'#c6d8d4',rgb:[198,216,212]}
],

};
